import type {CourseExpandedCommon} from '../../../api/course';

import {getCourseDisplayFields} from '../../../utils/entity/course';
import {envManager} from '../../../utils/env';
import {getPeriods} from './getPeriods';

export type ConferenceLimits = {
  introTotal: number;
  perPeriod: number;
  total: number;
};

export function getConferenceLimits(
  course: CourseExpandedCommon,
): ConferenceLimits {
  const periods = getPeriods(course);

  if (envManager.isB2b) {
    const subtenant = course.subtenant;

    const regularConferencesCount = subtenant?.session_count || 0;
    const extraConferencesCount = subtenant?.extra_sessions_limit || 0;

    const perPeriod = regularConferencesCount + extraConferencesCount;

    return {
      introTotal: 0,
      perPeriod,
      total: perPeriod * periods.length,
    };
  }

  const clientConferences = getCourseDisplayFields(course).clientConferences;
  const regularConferencesCount = clientConferences?.count || 0;

  const extraConferencesCount =
    course.current_offer_id && course.currentOffer
      ? (course.currentOffer.client_conferences.extra_sessions_limit ?? 0)
      : (course.program.offer?.client_conferences.extra_sessions_limit ?? 0);

  /**
   * Intro calls are supported only for courses with an active used offer.
   * Courses without currentOffer follow the legacy/B2B path and intentionally
   * get no intro capacity from program.offer.
   */
  const introTotal =
    course.current_offer_id && course.currentOffer
      ? (course.currentOffer.client_conferences.intro_count ?? 0)
      : 0;

  const perPeriod = regularConferencesCount + extraConferencesCount;

  return {
    introTotal,
    perPeriod,
    total: perPeriod * periods.length + introTotal,
  };
}
